import React, { useEffect, useState } from "react";
import { AdminSidebar, AdminTab } from "../components/admin/AdminSidebar";
import { VenueManagementPage } from "@/features/venue-management/pages/VenueManagementPage";
import { OrganisationAssigning } from "../components/admin/OrganisationAssigning";
import { OrganisationSeeding } from "../components/admin/OrganisationSeeding";
import { AiSkillsSection } from "../components/settings/AiSkillsSection";
import { RoleManagement } from "../components/admin/RoleManagement/RoleManagement";
import UserManagement from "../components/admin/UserManagement";
import { UserManagementService } from "../services/userManagementService";

const AdminPortal: React.FC = () => {
  const [activeTab, setActiveTab] = useState<AdminTab>("users");
  const [pendingUsersCount, setPendingUsersCount] = useState(0);

  useEffect(() => {
    const loadPendingUsersCount = async () => {
      try {
        const result = await UserManagementService.getPendingUsersCount();
        if (!result.error) {
          setPendingUsersCount(result.count);
        }
      } catch (error) {
        console.error("Failed to load pending users count:", error);
      }
    };
    loadPendingUsersCount();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="flex h-screen">
        <AdminSidebar
          activeTab={activeTab}
          onTabChange={setActiveTab}
          pendingUsersCount={pendingUsersCount}
        />

        <div className="flex-1 overflow-auto">
          <div className="p-6">
            {activeTab === "users" ? (
              <UserManagement />
            ) : activeTab === "roles" ? (
              <RoleManagement />
            ) : activeTab === "ai-skills" ? (
              <AiSkillsSection />
            ) : activeTab === "org-seeding" ? (
              <OrganisationSeeding />
            ) : activeTab === "org-assigning" ? (
              <OrganisationAssigning />
            ) : activeTab === "manage-venues" ? (
              <VenueManagementPage />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPortal;
